//const serverURL = "http://localhost:8000/"
const serverURL = "https://sniper-server.onrender.com/"
export default serverURL;